module.exports = __webpack_public_path__ + "img/57.9b3d6270.jpg";